import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh';
import en from './locales/en';

const isChinese = navigator.language.toLowerCase().startsWith('zh');
export const currentLang = isChinese ? 'zh' : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    lng: currentLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
